import {Component, Input, OnInit} from '@angular/core';
import {NgbProgressbar} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-progress-bar-light',
  standalone: true,
  imports: [
    NgbProgressbar
  ],
  templateUrl: './progress-bar-light.component.html',
  styleUrls: ['./progress-bar-light.component.scss']
})
export class ProgressBarLightComponent implements OnInit {

  @Input() score: number;

  constructor() { }

  ngOnInit(): void {
  }

}
